import { NgModule } from "@angular/core";
import { RouterModule, Route } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatSnackBarConfig } from "@angular/material";
import { PasswordStrengthBarModule } from "ng2-password-strength-bar";

import { MaterialAppModule } from "../ngmaterial.module";

import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { DownloadRedirectComponent } from "./download-redirect/download-redirect.component";
import { CommonModule } from "../common/common.module";
import { SettingsComponent } from "./settings/settings.component";
import { MfaSettingsService } from "../common/authentication/mfa-settings/mfa-settings.service";
import { MfaComponent } from "../user/mfa/mfa.component";
import { AuthenticateGuard } from "../common/guards";
import { UserDashboardComponent } from "./user-dashboard.component";

const ROUTES: Route[] = [
	{
		path: "download",
		component: DownloadRedirectComponent
	}, {
		path: "user",
		component: UserDashboardComponent,
		canActivate: [
			AuthenticateGuard
		],
		children: [
			{
				path: "settings",
				component: SettingsComponent,
				canActivate: [
					AuthenticateGuard
				]
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(ROUTES),
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		PasswordStrengthBarModule,
		MaterialAppModule
	],
	providers: [
		MatSnackBarConfig,
		MfaSettingsService
	],
	declarations: [
		ResetPasswordComponent,
		DownloadRedirectComponent,
		SettingsComponent,
		MfaComponent,
		UserDashboardComponent
	],
	exports: [
		ResetPasswordComponent,
		DownloadRedirectComponent,
		SettingsComponent,
		MfaComponent,
		UserDashboardComponent
	]
})
export class UserModule { }
